import cn from 'classnames';
import { HelpText } from '#components/atoms/forms/help/HelpText.tsx';
import styles from './FieldSet.module.css';

type Props = {
  legend: React.ReactNode;
  helpText?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
};

export function FieldSet({ legend, helpText, className, children }: Props) {
  return (
    <fieldset className={cn(className, styles.FieldSet)}>
      <legend className={cn('h4 pad-0', { 'mb-24': !helpText, 'mb-4': helpText })}>{legend}</legend>
      {typeof helpText === 'string' ?
        <HelpText className="mb-16">{helpText}</HelpText>
      : helpText}
      <div className={styles.FieldSet_fields}>{children}</div>
    </fieldset>
  );
}
